import { put, all, takeLatest, select } from "redux-saga/effects";

import * as ActionTypes from "../actions/prepaySettings/PrepaySettingsActionsTypes";
import { ISwitchPrepaySchedule } from "../actions/prepaySettings/IPrepaySettingsActions";
import {
  switchPrepayScheduleSuccess,
  switchPrepayScheduleError,
} from "../actions/prepaySettings/PrepaySettingsActions";
import { IScheduleGroup } from "../types/IScheduleStore";
import { createScheduleGroupReq, deleteScheduleGroupReq } from "../api";
import { localStorageItems } from "../config/constants";
import { getScheduleList } from "../actions/schedules/SchedulesAction";

function* updatePrepayScheduleType(action: ISwitchPrepaySchedule) {
  const { isActiveRestaurantSchedule } = action.payload;

  if (isActiveRestaurantSchedule) {
    const scheduleList: Array<IScheduleGroup> = yield select(
      (state) => state.schedule.prepaySchedules,
    );

    if (scheduleList.length > 0) {
      yield deleteScheduleGroupReq(scheduleList.map((d) => d.id));
      const prepareForSave = scheduleList.map((i) => ({
        day: i.day,
        restaurantId: i.restaurantId,
        type: i.type,
        records: i.records.map((r) => ({
          start: r.start,
          end: r.end,
          isWorkingTime: r.isWorkingTime,
          day: r.day,
          type: r.type,
        })),
      }));

      localStorage.setItem(
        localStorageItems.autoPrepaySchedule,
        JSON.stringify(prepareForSave),
      );
    }

    yield put(switchPrepayScheduleSuccess(isActiveRestaurantSchedule));
  } else {
    try {
      const savedSchedule = yield localStorage.getItem(
        localStorageItems.autoPrepaySchedule,
      );
      const parsedSchedule: Array<IScheduleGroup> = savedSchedule
        ? yield JSON.parse(savedSchedule)
        : null;

      if (parsedSchedule && parsedSchedule.length > 0) {
        yield createScheduleGroupReq(parsedSchedule);
        yield put(getScheduleList());
      }

      localStorage.setItem(localStorageItems.autoPrepaySchedule, "");

      yield put(switchPrepayScheduleSuccess(isActiveRestaurantSchedule));
    } catch (e) {
      yield put(switchPrepayScheduleError());
    }
  }
}

export default function* saga() {
  yield all([
    takeLatest(
      ActionTypes.SWITCH_PREPAY_SCHEDULE_TYPE_REQUEST,
      updatePrepayScheduleType,
    ),
  ]);
}
